import React from 'react';
import loadable from '@loadable/component';
import MobilePartnerLogo from './components/mlp-mobile-logos';
import CompareDrawer from '../compare/components/compare-drawer';
import withPage, { loadGraphQLData } from '../page';

const MLP = loadable(() => import('./components'));

const MLPContainer = ({ slugInfo }) => {
    return (
        <>
            <MLP slugInfo={slugInfo} />
            <MobilePartnerLogo />
            <CompareDrawer />
        </>
    );
};

export default {
    component: withPage(MLPContainer, {
        wrapperClassName: 'mdp-root',
        showWordCloud: true,
        useV2: true,
        useGraphQL: true,
    }),
    loadData: loadGraphQLData,
};
